import { GlobalOnlyUploadService } from "@common/service/data-service/upload";
import UserService from "@common/service/data-service/user/user";
import AuthService from "@common/ict/service/auth";
import {
  ICTServerTimeService,
  ExamService,
  RequestService
} from "./commonAdapter";
UserService.setRequest(RequestService);
AuthService.setRequest(RequestService);
ICTServerTimeService.setRequest(RequestService);
ExamService.setRequest(RequestService);
GlobalOnlyUploadService.setRequest(RequestService);
export {
  AuthService,
  UserService,
  ICTServerTimeService,
  ExamService,
  RequestService,
  GlobalOnlyUploadService
};
